import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Introducao() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('intro_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('intro_description')}
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <div className="grid md:grid-cols-2 gap-8 items-center mb-8">
            <div>
              <h2 className="text-2xl font-semibold mb-4">{t('intro_title')}</h2>
              <p className="text-gray-700 leading-relaxed">
                {t('intro_description')}
              </p>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/18370031fd4e1896931ba511a17f893f.jpg"
                alt={t('intro_title')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>

          <h3 className="text-xl font-semibold mb-4">{t('intro_description')}</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <div className="bg-blue-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-3">
                <i className="ri-truck-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold mb-2">{t('intro_feature1')}</h4>
            </div>

            <div className="bg-green-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-3">
                <i className="ri-sort-asc text-2xl text-green-600"></i>
              </div>
              <h4 className="font-semibold mb-2">{t('intro_feature2')}</h4>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg mb-3">
                <i className="ri-qr-scan-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold mb-2">{t('intro_feature3')}</h4>
            </div>

            <div className="bg-orange-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-3">
                <i className="ri-route-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="font-semibold mb-2">{t('intro_feature4')}</h4>
            </div>

            <div className="bg-red-50 p-6 rounded-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-lg mb-3">
                <i className="ri-eye-line text-2xl text-red-600"></i>
              </div>
              <h4 className="font-semibold mb-2">{t('intro_feature5')}</h4>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-lg mb-8">
            <h3 className="text-xl font-semibold mb-3">{t('intro_beumer')}</h3>
            <p className="leading-relaxed">
              {t('intro_beumer')}
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_home')}
          </Link>
          <Link 
            to="/componentes"
            className="flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_components')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
